import { Directive, TemplateRef, OnChanges, inject, input, contentChild } from '@angular/core';
import { ColumnChangesService } from '../../services/column-changes.service';
import { TableColumnProp } from '../../types/table-column.type';
import { DataTableColumnHeaderDirective } from './column-header.directive';
import { DataTableColumnCellDirective } from './column-cell.directive';
import { DataTableColumnCellTreeToggle } from './tree.directive';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'ngx-datatable-column'
})
export class DataTableColumnDirective implements OnChanges {
  private readonly columnChangesService = inject(ColumnChangesService);

  readonly name = input<string>(undefined);
  readonly prop = input<TableColumnProp>(undefined);
  readonly frozenLeft = input<unknown>(undefined);
  readonly frozenRight = input<unknown>(undefined);
  readonly flexGrow = input<number>(undefined);
  readonly resizeable = input<boolean>(undefined);
  readonly comparator = input<unknown>(undefined);
  readonly pipe = input<unknown>(undefined);
  readonly sortable = input<boolean>(undefined);
  readonly rowheader = input<boolean>(undefined);
  readonly draggable = input<boolean>(undefined);
  readonly canAutoResize = input<boolean>(undefined);
  readonly minWidth = input<number>(undefined);
  readonly width = input<number>(undefined);
  readonly maxWidth = input<number>(undefined);
  readonly checkboxable = input<boolean>(undefined);
  readonly headerCheckboxable = input<boolean>(undefined);
  readonly headerClass = input<string | ((data: unknown) => string | unknown)>(undefined);
  readonly cellClass = input<string | ((data: { row: unknown; column: unknown; value: unknown; group?: unknown; rowHeight?: number | 'auto' }) => string | Record<string, boolean> | unknown)>(undefined);
  readonly isTreeColumn = input<boolean>(undefined);
  readonly treeLevelIndent = input<number>(undefined);
  readonly summaryFunc = input<(cells: Array<unknown>) => unknown>(undefined);
  readonly summaryTemplate = input<TemplateRef<unknown>>(undefined);

  readonly _cellTemplateInput = input<TemplateRef<unknown>>(undefined, { alias: 'cellTemplate' });

  readonly _cellTemplateQuery = contentChild(DataTableColumnCellDirective, { read: TemplateRef });

  get cellTemplate(): TemplateRef<unknown> {
    return this._cellTemplateInput() || this._cellTemplateQuery();
  }

  readonly _headerTemplateInput = input<TemplateRef<unknown>>(undefined, { alias: 'headerTemplate' });

  readonly _headerTemplateQuery = contentChild(DataTableColumnHeaderDirective, { read: TemplateRef });

  get headerTemplate(): TemplateRef<unknown> {
    return this._headerTemplateInput() || this._headerTemplateQuery();
  }

  readonly _treeToggleTemplateInput = input<TemplateRef<unknown>>(undefined, { alias: 'treeToggleTemplate' });

  readonly _treeToggleTemplateQuery = contentChild(DataTableColumnCellTreeToggle, { read: TemplateRef });

  get treeToggleTemplate(): TemplateRef<unknown> {
    return this._treeToggleTemplateInput() || this._treeToggleTemplateQuery();
  }

  private isFirstChange = true;

  ngOnChanges(): void {
    if (this.isFirstChange) {
      this.isFirstChange = false;
    } else {
      this.columnChangesService.onInputChange();
    }
  }
}
